// google maps implementation

function initMap() {
    map = new google.maps.Map(document.getElementById('leaflet-map'), {
        center: new google.maps.LatLng(0, 0),
        zoom: 2.5,
        styles: mapStyle,
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        minZoom: 2.5,
        zoomControl: true,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL
        }
    });

    map.addListener('dragstart', function() {
        $('.marker-parent').removeClass('active');
    });

    if($(window).width() > 768) {
        scrollbar.addListener(function(s) {
            $('.marker-parent').removeClass('active');
        });
    } else {
        $(window).scroll(function () { 
            $('.marker-parent').removeClass('active');
        });
    }

    for (var i = 0; i < locations.length; i++) {
        var item = locations[i];
        var slug = item[1];
        var html = markerHTML(slug, item[0], item[5]);
        let marker = createHTMLMapMarker({
            latlng: new google.maps.LatLng(item[2], item[3]),
            map: map,
            html: html,
            slug: slug
        });

        marker.addListener("click", function(e) {
            $('.marker-parent').removeClass('active');
            $('.pin-marker.marker-' + marker.slug).parent('.marker-parent').addClass('active');
            // map.setZoom(8);
            map.setCenter(marker.getPosition());
            map.panBy(0,-30);
            // console.log(marker.slug);

            // event push
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'home.map.click',
            });
        });

        markers.push(marker);
    }

    function markerHTML(slug, label, percentage) {
        var markerhtml = 
            '<div class="pin-marker marker-'+ slug +'">'+
                '<div class="label">' + label + '</div>' +
                '<div class="info">' +
                    '<div class="svg-item">'+
                        '<svg width="120px" height="120px" viewBox="0 0 40 40" class="donut">'+
                            '<circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#fff"></circle>'+
                            '<circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5"></circle>'+
                            '<circle class="donut-segment donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5" stroke-dasharray="'+ percentage +' '+ (100 - percentage) +'" stroke-dashoffset="25"></circle>'+
                        '</svg>'+
                    '</div>'+
                    '<div class="text">' + percentage + '%</div>' +
                '</div>'+
            '</div>' ;
        
        return markerhtml;
    }

    function centeredMap() {

		var bounds = new google.maps.LatLngBounds();
		for(i=0;i<markers.length;i++) {
		   bounds.extend(markers[i].getPosition());
		//    console.log(markers[i].getPosition());
		}

		//center the map to a specific spot (city)
		map.setCenter(new google.maps.LatLng(0, 0)); 

		//center the map to the geometric center of all markers
		map.setCenter(bounds.getCenter());

		map.fitBounds(bounds);

		//remove one zoom level to ensure no marker is on the edge.
		// map.setZoom(map.getZoom()); 
		// console.log(map.getZoom());
		// set a minimum zoom 
        // if you got only 1 marker or all markers are on the same address map will be zoomed too much.
        
        // console.log(map.getZoom());
		if(map.getZoom() > 15){
            map.setZoom(5);
            // console.log('teest');
		}else{
            // console.log(map.getZoom());
			map.setZoom(map.getZoom()); 
		}
        // console.log(map.getZoom());
		//Alternatively this code can be used to set the zoom for just 1 marker and to skip redrawing.
		//Note that this will not cover the case if you have 2 markers on the same address.
		if(markers.length == 1){
		    // map.setMaxZoom(15);
		    // map.fitBounds(bounds);
		    // map.setMaxZoom(Null)
		}

		// map.fitBounds(bounds);
    }

    centeredMap();
}

$(document).ready(function () {
    setTimeout(function() {
        initMap();
    }, 3000);
});